;(() => {
  if (customElements.get('shop-module')) {
    return
  }

  class ShopModule extends HTMLElement {
    constructor() {
      super()

      this.handleHotspotChange = this.hotspotChange.bind(this)

      this.slider = null
      this.hotspots = this.querySelectorAll('[data-hotspot]')

      this.hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', this.handleHotspotChange)
      })
    }

    connectedCallback() {
      this.sliderInit()
    }

    sliderInit() {
      const $sliderElement = this.querySelector('.splide')
      const sliderMobileWidth =
        $sliderElement.dataset.sliderMobileWidth || 'calc(335 / 375 * 100%)'
      const sliderHeightRatio = $sliderElement.dataset.heightRatio || 1.41

      this.slider = new Splide($sliderElement, {
        waitForTransition: true,
        arrows: false,
        pagination: true,
        wheel: true,
        releaseWheel: true,
        direction: 'ttb',
        heightRatio: sliderHeightRatio,
        fixedWidth: '100%',
        gap: '2px',
        speed: '700',
        breakpoints: {
          990: {
            heightRatio: 1.5,
          },
          750: {
            direction: 'ltr',
            heightRatio: false,
            fixedWidth: sliderMobileWidth,
          },
        },
      }).mount()

      this.slider.on('active', (Slide) => {
        this.hotspots.forEach((hotspot) => {
          hotspot.classList.remove('is-active')

          if (hotspot.dataset.key === Slide.slide.dataset.key) {
            hotspot.classList.add('is-active')
          }
        })
      })
    }

    hotspotChange(e) {
      e.preventDefault()

      if (e.target.classList.contains('is-active')) {
        return
      }

      this.hotspots.forEach((hotspot) => {
        hotspot.classList.remove('is-active')
      })
      e.target.classList.add('is-active')

      this.slider.go(
        this.slider.Components.Elements.slides.findIndex(
          (slide) => slide.dataset.key === e.target.dataset.key
        )
      )
    }
  }

  customElements.define('shop-module', ShopModule)
})()
